<template>
  <div class="category-block">
    <router-link :to="getRoute(category)">
      <div
        v-if="imageLoading"
        class="d-flex justify-content-center"
        style="margin-top: 6%; height: 150px; align-items: center"
      >
        <div class="spinner-border" role="status" style="">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <img
        :src="category.url"
        :alt="category.title"
        class="category-image"
        v-show="!imageLoading"
        @load="imageLoading = false"
      />
      <div class="category-title">{{ category.title }}</div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "CategoryBlock",
  props: {
    category: {
      type: Object,
      default() {
        return {
          id: 0,
          title: "",
          url: "",
          items: [
            {
              id: 0,
              title: "",
              description: "",
              price: "",
              allergens: null,
              url: "",
              url_low: "",
            },
          ],
        };
      },
    },
  },
  data() {
    return {
      imageLoading: true,
    };
  },
  computed: {
    parents() {
      if (!this.$route.query.parent) return [];
      const parents = this.$route.query.parent.split(",").map(Number);
      return parents;
    },
  },
  methods: {
    getRoute(category) {
      if (category.subCategories) {
        const parentsString = [...this.parents, category.id].join(",");
        // Route to categories with query
        return {
          name: "Categories",
          query: {
            lang: this.$route.query.lang,
            parent: parentsString,
          },
        };
      } else {
        const parentsString = [...this.parents].join(",");
        // Route to items
        return {
          name: "Items",
          query: {
            lang: this.$route.query.lang,
            parent: parentsString,
          },
          params: { id: category.id },
        };
      }
    },
  },
};
</script>

<style scoped>
.category-block {
  position: relative;
  width: calc(50% - 0.2rem);
  height: 11rem;
  overflow: hidden;
  margin: 0.4rem;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  border-radius: 1rem;
}

.category-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  -webkit-mask-image: linear-gradient(
    180deg,
    #000000 40%,
    rgba(0, 212, 255, 0)
  );
}

.category-title {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0.5rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5); /* semi-transparent black */
  color: white;
}
</style>
